import { render, staticRenderFns } from "./homeCp.vue?vue&type=template&id=33f0e423&scoped=true&"
import script from "./homeCp.vue?vue&type=script&lang=js&"
export * from "./homeCp.vue?vue&type=script&lang=js&"
import style0 from "./homeCp.vue?vue&type=style&index=0&id=33f0e423&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f0e423",
  null
  
)

export default component.exports